import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SortbyPipe } from '@netfoundry-ui/ui/pipes';
import { AgentService, ApiService, ClientCertificateService, HealthCheckService, ShareService } from '@netfoundry-ui/shared/services';
import { NetworkV2, Provider, RegionV2, AllocatedIp, HealthCheck, ClientCertificate } from '@netfoundry-ui/shared/model';
import { GrowlerData, GrowlerService } from '@netfoundry-ui/shared/growler';
import { ActivatedRoute, Router } from '@angular/router';
import _, { cloneDeep, unset, isEmpty } from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import { Subject, Subscription } from 'rxjs';

@Component({
    selector: 'app-client-certificate-form',
    templateUrl: './client-certificate-form.component.html',
    styleUrls: ['./client-certificate-form.component.scss'],
    standalone: false
})
export class ClientCertificateFormComponent implements OnInit {
    model: ClientCertificate;
    displayedRegions: RegionV2[] = [];
    providers: Provider[] = [];

    @Input() isModal = false;
    @Input() formData: any = {};
    close: EventEmitter<any> = new EventEmitter<any>();
    orgId
    frontdoorId
    isV2
    valueError = false;
    moreActions: any[] = [];
    valueMessage
    nameError = false
    nameErrorMessage
    isEditing = false;
    showError= false;
    errorMessage;
    formView = 'simple';
    @Input() entityId: string;

    errMap:  any = {};
    timeout = Date.now() + 10 * 60 * 1000; 
    processing = false;

    saveSubject = new Subject<boolean>;
    mappingConfigUpdateSubject = new Subject<boolean>;
     formInit = false;
    protected isLoading = false;
    subscription: Subscription = new Subscription();
    initData: any = {};
    @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
    public errors: any = {};
    basePath = '';
    previousRoute;
    protected usePreviousLocation = true;
    baseHref: any;
    _dataChange = false;

    constructor(
        private sortByPipe: SortbyPipe,
        private apiService: ApiService,
        private svc: ClientCertificateService,
        private agentService: AgentService,
        public growlerService: GrowlerService,
        protected router?: Router,
        protected route?: ActivatedRoute,
    ) {
    this.previousRoute = router?.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
        this.subscription.add(
            this.route?.params?.subscribe(params => {
                const id = params['id'];
                if (isEmpty(id)) {
                    this.entityId = 'create';
                } else {
                  this.entityId = id;
                }
            })
        );
        this.subscription.add(
            router?.events.subscribe((event: any) => {
                  if (!event?.snapshot?.routeConfig?.path) {
                      return;
                  }
                  const pathSegments = event.snapshot.routeConfig.path.split('/');
                  this.basePath = pathSegments[0];
                
            })
        );
        this.initBaseHref();
    }

    ngOnInit() {

        this.subscription.add(
            this.apiService.currentTenant.subscribe((tenant) => {
                this.orgId = tenant.id;
                this.agentService.getAccountById(this.orgId).subscribe((frontdoor: any) => {
                    this.frontdoorId = frontdoor.id;
                    if(frontdoor.version === 1) {
                        this.isV2 = false
                    } else {
                        this.isV2 = true
                    }
                    if (this.entityId === 'create') {
                        this.formData = new ClientCertificate();
                        this.initData = cloneDeep(this.formData);
                        this.entityUpdated();
                        return;
                    } else {
                        this.isEditing = true;
                        this.isLoading = true;
                        this.getSingleClientCertificate();
                    }
                })
            })
        );
    }



    closeForm(refresh = true, ignoreChanges = false, data?, event?) {
      if (!ignoreChanges && this._dataChange) {
          const confirmed = confirm('You have unsaved changes. Do you want to leave this page and discard your changes or stay on this page?');
          if (!confirmed) {
              return;
          }
      }
      if (this.isModal) {
          this.closeModal(refresh, ignoreChanges);
      } else {
          this.returnToListPage();
      }
    }

    save(event?: any) {
        this.processing = true;
        this.isLoading = true;

        
        const proms = [];

        if (this.isEditing) {
            this.saveSubject.next(true);
            const updateSubjectPromise = new Promise<boolean>((resolve) => {
            // Note: Consider taking(1) so this doesn't hang
            this.mappingConfigUpdateSubject.asObservable().subscribe((wasUpdated: boolean) => {
                resolve(wasUpdated);
            });
            });
            proms.push(updateSubjectPromise);
        } else {
            // If not editing, we push 'true' so the Promise.all logic stays consistent
            proms.push(Promise.resolve(true));
        }

        const httpCall = this.isEditing 
            ? this.svc.update( this.formData, this.frontdoorId,  this.formData.id, this.isV2)
            : this.svc.create(this.formData, this.frontdoorId, this.isV2 );

        const requestPromise = new Promise((resolve, reject) => {
            httpCall.subscribe({
            next: (result: any) => {
                if (this.isModal) {
                this.closeModal(true, true);
                } else {
                this.initData = this.formData;
                this.formData = result;
                this._dataChange = false;
                this.isLoading = false;
                this.returnToListPage()
                }
                resolve(true);
            },
            error: (err) => {
                this.processErrors(err);
                this.isLoading = false;
            }
            });
        });


        proms.push(requestPromise);

        // 3. Finalize
        Promise.all(proms)
            .then((results) => {
            // results[0] is the Subject, results[1] is the HTTP call
            if (results.every(res => res === true)) {
                this.returnToListPage();
                // TODO: Success message
            }
            })
            .catch(err => {
            // Handle errors here
            })
            .finally(() => {
            this.processing = false;
            this.isLoading = false;
            });
        }

    returnToListPage() {
      // Certificates is a tab on the TCP shares page, not a page of its own.
      this.router?.navigateByUrl(`${this.basePath}/tcp-shares?tab=certificates`);
    }

      closeModal(refresh = true, ignoreChanges = false, data?: any, event?: any): void {
        this.close.emit({refresh: refresh});
        if (event) {
            event.stopPropagation();
        }
    }

            processErrors(errorResponse: any) {
            const errors: string[] = errorResponse?.error?.errors || [];
            const valueError = errors.find(e => e.includes('value'));
            const nameError = errors.find(e => e.includes('name'))
            if(valueError) {
                this.valueError = true;
                this.valueMessage =  valueError.split(':').slice(1).join(':').trim();
            }
            if(nameError) {
                this.nameError = true;
                this.nameErrorMessage =  nameError.split(':').slice(1).join(':').trim();
            }
            else {
                this.growlerService.show(
                        new GrowlerData(
                            'error',
                            'Client certificate save request failed',
                            'Client certificate save request has failed.'
                    )
            );
            }
            
}


    initBaseHref() {
        try {
            const base = document?.querySelector('base');
            this.baseHref = base ? base.getAttribute('href') : '/';
        } catch (error) {
            this.baseHref = '/';
        }
    }

    entityUpdated() {
            if (this.formData.id) {
            }
            
            unset(this.formData, '_links');
            this.initData = cloneDeep(this.formData);
        }

    headerActionRequested(action: any) {
        switch(action.name) {
            case 'save':
                this.save();
                break;
            case 'close':
                this.closeForm();
                break;
            case 'toggle-view':
                this.formView = action.data;
                break;
            }
        }

    getSingleClientCertificate() {
            return this.svc.getClientCertificateById(this.frontdoorId, this.entityId, this.isV2).subscribe({
        next: (entity: ClientCertificate) => {
            this.formData = entity;
            this.initData = cloneDeep(this.formData);
            this.entityUpdated();
            this.isLoading = false;
        },
        error: (err) => {
            this.growlerService.show(
            new GrowlerData(
                'error',
                'Error',
                'Error retrieving client certificate data.',
            )
        );
        }
        }) 
    }


    /**
     * True when this form is showing an existing entity. Derived from the route/input
     * rather than the loaded record, so the header title doesn't briefly read
     * "Create New ..." while the record is still being fetched.
     */
    get isExistingEntity(): boolean {
        return !isEmpty(this.formData?.id) || (!isEmpty(this.entityId) && this.entityId !== 'create');
    }

}
